import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../dialogs/Dialog';
import _ from 'lodash';

/**
 * Edit text cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const EditPhoneNoCell = ({ getColumns }) => {
  class EditPhoneNoCell extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        value: null,
        isDialogOpen: false,
      }
    }

    handleDialogClose = () => {
      this.setState({ isDialogOpen: false });
    }

    handleDialogOpen = () => {
      const { dataItem, field } = this.props;
      this.setState({ isDialogOpen: true, value: dataItem[field] || '' });
    }

    handleDialogConfirm = async (e) => {
      this.setState({ isDialogOpen: false });

      this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e,
        value: this.state.value
      });
    }

    handleFocus = (e) => {
      e.target.selectionStart = 0;
      e.target.selectionEnd = e.target.value.length;
    }

    handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.stopPropagation();
      }
      if (e.key === "Escape") {
        this.setState({ isDialogOpen: false });
        e.stopPropagation();
      }
    }

    handleChange = (e) => {
      let element = document.getElementsByClassName("k-grid-edit-cell")
      if (element) {
        if (!(/([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)/g).test(e.target.value)) {
          element[4].classList.add("incomplete-number");
        }
        else {
          element[4].classList.remove("incomplete-number");
        }
      }

      this.setState({ value: e.target.value });

      this.props.onChange(
        {
          dataItem: this.props.dataItem,
          field: this.props.field,
          syntheticEvent: e,
          value: e.target.value
        });
    }

    render() {
      const { dataItem, field, style, colSpan, columnIndex, level } = this.props;
      const dataValue = _.get(dataItem, field.split('.')) || '';
      const column = getColumns().find(item => item.field === field)
      let className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;
      const td = (
        <td colSpan={colSpan}
          className={className}
          style={style}
          role="gridcell"
          aria-colindex={(columnIndex || 0) - (level || 0) + 1}
          aria-selected={false}
          tabIndex="0"
        >
          {((dataItem.inEdit === true || dataItem.inEdit === field) && column.editable !== false) ? (
            <input
              style={{ width: "100%" }}
              onChange={this.handleChange}
              className={"k-textbox"}
              value={dataValue}
              onDoubleClick={this.handleDialogOpen}
              onKeyPress={(event) => {
                if (!(/^[0-9+ ]+$/).test(event.key)) {
                  event.preventDefault();
                }
              }}
              type="tel"
              minLength="10"
              maxLength="13"
            />
          ) : (
            dataValue
          )}
          {this.state.isDialogOpen && <Dialog
            title={"Editácia textu"}
            isOpen={this.state.isDialogOpen}
            onClose={this.handleDialogClose}
            onConfirm={this.handleDialogConfirm}
          >
            <textarea
              className="k-textarea"
              value={this.state.value}
              onChange={(e) => { this.setState({ value: e.target.value }); }}
              style={{ width: "100%" }}
              autoFocus={true}
              onFocus={this.handleFocus}
              onKeyDown={this.handleKeyDown}
            />
          </Dialog>
          }
        </td>
      );

      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }
  EditPhoneNoCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  }

  return EditPhoneNoCell;
}